<template>
<div class="Associate-Bonus-Module">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="showBonusAssociateOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row bottom-border-with-styles">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc padding-left-4Point4 create-element-overlay-course-title-font-styles">
                      {{getCurrentlySelectedCourseObj.CourseTitle}}
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc margin-top-6-Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Bonus Lesson
                </div>
                <div class="col-md-4 col-lg-4 text-align-left font-weight-bold create-lesson-input-text-style ">
                  <div class="form-group">
                        <div class="col-sm-12">
                            {{bonusModuleServerRespObj.Title}}
                        </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  <!-- Index -->
                  Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <!-- <input type="text" class="form-control" v-model="BonusIndexValue"> -->
                            <input type="text" class="form-control" v-model="BonusTitleValue">
                        </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <!-- if user not coming from Bonus element creation > Bonus Module Creationg then show complete dropdownlist -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedLessonObj === undefined">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Associate with
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                      <div class="col-sm-12">
                          <select class="form-control" v-model="choosenLessonObj">
                          <option value='-1' disabled>Select</option>
                          <option v-for="lessonObj in getLessonList" v-bind:key="lessonObj.UserModuleId" v-if="!lessonObj.IsBonusContent" v-bind:value="lessonObj">{{ lessonObj.Title }}</option>
                        </select>
                      </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <!-- if user coming from Bonus element creation > Bonus Module Creationg then show only selected Lesson option in dropdownlist -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedLessonObj !== null && selectedLessonObj !== undefined">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Associate with
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                      <div class="col-sm-12">
                          <select class="form-control" v-model="choosenLessonObj">
                          <option value='-1' disabled>Select</option>
                          <option v-for="lessonObj in getLessonList" v-bind:key="lessonObj.UserModuleId" v-if="lessonObj.ModuleId === selectedLessonObj.ModuleId" v-bind:value="lessonObj">{{ lessonObj.Title }}</option>
                        </select>
                      </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row margin-bottom-6Perc margin-Top-4Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="associateBonus">Associate</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="redirectToAddBonusVideoScreen"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import { bonusService } from '@/server-util/bonus-service'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['bonusModuleServerRespObj', 'selectedLessonObj'],
  created: function () {
    this.setBonusModuleId()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      topicName: null,
      showSpinner: false,
      choosenLessonObj: -1,
      elementObj: {
        ModuleId: '',
        Title: '',
        Duration: '',
        BonusModuleId: -1,
        Index: null
      },
      showConfirmationBox: false,
      prefixString: 'Are you sure you want to delete ',
      postString: '?'
    }
  },
  name: 'Associate-Bonus-Module',
  methods: {
    redirectToAddBonusVideoScreen (value) {
      // AK: Used to redirect user to Add bonus video screen if admin pressed ok button
      this.$emit('isBonusAssocited', true)
      this.$emit('wantToAddMoreVideo', true)
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
      // AK: User got confirmation msg means its associated so set flag as true
      this.$emit('isBonusAssocited', true)
      // AK: User pressed cancel or X so emit wantToAddMoreVideo as false
      this.$emit('wantToAddMoreVideo', false)
    },
    setBonusModuleId: function () {
      // AK: Used to set bonus module Id
      this.elementObj.BonusModuleId = this.bonusModuleServerRespObj.ModuleId
    },
    showBonusAssociateOverlay: function (event, flagToUpdate) {
      this.$emit('isBonusAssocited', false)
    },
    associateBonus: function (event) {
      // AK: Check is title is empty?
      if (this.elementObj.Title.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return
      }
      // AK: Check is Lesson selected
      if (this.choosenLessonObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a lesson.'
        return
      } else {
        // AK: If selected then assign value to it
        this.elementObj.ModuleId = this.choosenLessonObj.ModuleId
      }
      // console.log('Before Link >>>> ' + JSON.stringify(this.elementObj))
      var _this = this
      var storeObj = this.$store
      if (this.elementObj !== undefined) {
        // AK: Start showing spinner
        // _this.showSpinner = true
        this.$store.state.isLoading = true
        bonusService
          .addBonusContent(storeObj.state.access_token, _this.elementObj)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Hide spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                // AK: Show success Msg to user
                _this.showConfirmationBox = true
                _this.prefixString = 'Bonus content \'' + _this.bonusModuleServerRespObj.Title + '\' has associated successfully. '
                _this.postString = 'Do you want to add more video(s)?'
              } else {
                // AK: Hide Spinner
                // _this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // _this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected ElementObj is NULL hence declined CREATE BONUS CONTENT OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader
  },
  computed: {
    getLessonList: {
      get: function () {
        return this.$store.state.selectedMasterClassModuleList
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    BonusTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    BonusIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        if (newValue.trim() !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            if (parseInt(newValue) >= 1000) {
              this.errorMsg = 'Index should be less than 1000.'
              this.showAlertDialog = true
              this.elementObj.Index = null
            } else {
              this.elementObj.Index = parseInt(newValue)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.elementObj.Index = null
          }
        } else {
          this.elementObj.Index = null
        }
      }
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-4Perc
{
	margin-top: 4%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-bottom-6Perc
{
	margin-bottom: 6%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;
}
.margin-top-6-Perc {
  margin-top: 6%;
}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.font-weight-bold {
  font-weight: bold
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000 !important;
}
.create-element-overlay-course-title-font-styles {
  font-size: 18px;
  color: #34495e;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.bottom-border-with-styles {
  border-bottom: 1px solid #ddd;
  width: 96%;
  margin-left: 0%;
  padding-bottom: 1%; 
}
</style>


// WEBPACK FOOTER //
// src/components/AssociateBonusContentWithLesson.vue